import { IPublicClientApplication } from "@azure/msal-browser";
import { apiLoginRequest } from "../Config";
import ProjectSheetModel from "../Models/ProjectSheetModel";

export default class ProjectSheetService {
  msalInstance: IPublicClientApplication;

  baseUrl = process.env.REACT_APP_API_URL;

  constructor(msalInstance: IPublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  public async get(projectCode: string): Promise<ProjectSheetModel> {
    const accessToken = await this.acquireAccessToken();

    let data = await fetch(
      `${this.baseUrl}/api/projectsheet?code=${projectCode}`,
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + accessToken,
        }),
      }
    )
      .then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response;
      })
      .then((returnedResponse) => {
        return returnedResponse;
      })
      .catch((error) => {
        // Your error is here!
        console.log(error);
        throw error;
      });

    const dataText = await data.text();
    //if(dataText.length)
    return dataText.length
      ? JSON.parse(dataText)
      : { projectCode: projectCode };
  }

  public async upsert(projectSheet: ProjectSheetModel) {
    const accessToken = await this.acquireAccessToken();
    await fetch(`${this.baseUrl}/api/projectsheet`, {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + accessToken,
      }),
      body: JSON.stringify(projectSheet),
    })
      .then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response;
      })
      .catch((error) => {
        // Your error is here!
        console.log(error);
        throw error;
      });
  }

  private async acquireAccessToken() {
    const account = this.msalInstance.getActiveAccount();
    if (!account) {
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    }

    const authResult = await this.msalInstance.acquireTokenSilent({
      ...apiLoginRequest,
      account: account,
    });

    return authResult.accessToken;
  }
}
